/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_TitleInputs */

const vi_reconcile_title = /** @type {(inputs: Reconcile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đối soát chuyển khoản`)
};

/**

* @param {Reconcile_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_title = /** @type {((inputs?: Reconcile_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_title(inputs)
});